import UserProfileRoutes from "./UserProfileRoutes";

export default UserProfileRoutes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/users/UserProfileRoutes/index.tsx